module.exports = __webpack_public_path__ + "img/Group 102.df866876.jpg";